// wave4-nav-ia fix7: Ale's rail icons, VERBATIM from her coowe.html `h` icon map (same paths,
// same stroke widths, currentColor). Rendered inline so stroke weight/color match her rows
// exactly (our masked SvgIcon set had mixed glyph weights).
import React from "react"

const base = { width: 18, height: 18, viewBox: "0 0 24 24", fill: "none", stroke: "currentColor" }

export const IconPlus = () => (
  <svg {...base} strokeWidth="1.8">
    <path d="M12 5v14M5 12h14" />
  </svg>
)

// wave4-fix9 (QJ): PLANNER line icon -- clipboard with ruled lines + a check (pngtree
// "planner line icon" reference), drawn in her icon language (24 viewBox, minimal line style,
// currentColor). Replaces her house glyph per QJ.
export const IconPlanflow = () => (
  <svg {...base} strokeWidth="1.7">
    <rect x="5" y="4" width="14" height="18" rx="2" />
    <path d="M9 4V3a1 1 0 0 1 1-1h4a1 1 0 0 1 1 1v1" />
    <path d="M9 10h6M9 13.5h6" />
    <path d="M9 17.5l1.7 1.7 3.3-3.4" />
  </svg>
)

// her `teeups` icon -- used for Inbox (the TeeUps surface)
export const IconInbox = () => (
  <svg {...base} strokeWidth="1.7">
    <rect x="3" y="4" width="18" height="17" rx="2" />
    <path d="M3 9h18M8 2v4M16 2v4M8.5 14l2.2 2.2L15.5 12" />
  </svg>
)

export const IconCalendar = () => (
  <svg {...base} strokeWidth="1.7">
    <rect x="3" y="4" width="18" height="17" rx="2" />
    <path d="M3 9h18M8 2v4M16 2v4" />
  </svg>
)

export const IconMessages = () => (
  <svg {...base} strokeWidth="1.7">
    <path d="M21 15a2 2 0 0 1-2 2H8l-5 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z" />
  </svg>
)

// her `rel` (Relationships) icon -- used for People
export const IconPeople = () => (
  <svg {...base} strokeWidth="1.7">
    <circle cx="18" cy="5" r="2.6" />
    <circle cx="6" cy="12" r="2.6" />
    <circle cx="18" cy="19" r="2.6" />
    <path d="M8.3 10.7l7.4-4.4M8.3 13.3l7.4 4.4" />
  </svg>
)

// ticket #216 (web-nav-align-2026-07-09): simple gear glyph, her icon language (24 viewBox,
// minimal line style, currentColor) -- used for the new primary "Settings" row (mobile-parity).
export const IconSettings = () => (
  <svg {...base} strokeWidth="1.6">
    <circle cx="12" cy="12" r="3" />
    <path d="M19.4 13.5a1.7 1.7 0 0 0 .34 1.87l.06.06a2 2 0 1 1-2.83 2.83l-.06-.06a1.7 1.7 0 0 0-1.87-.34 1.7 1.7 0 0 0-1.04 1.56V19.5a2 2 0 1 1-4 0v-.09a1.7 1.7 0 0 0-1.04-1.56 1.7 1.7 0 0 0-1.87.34l-.06.06a2 2 0 1 1-2.83-2.83l.06-.06a1.7 1.7 0 0 0 .34-1.87 1.7 1.7 0 0 0-1.56-1.04H4.5a2 2 0 1 1 0-4h.09a1.7 1.7 0 0 0 1.56-1.04 1.7 1.7 0 0 0-.34-1.87l-.06-.06a2 2 0 1 1 2.83-2.83l.06.06a1.7 1.7 0 0 0 1.87.34H10.5a1.7 1.7 0 0 0 1.04-1.56V4.5a2 2 0 1 1 4 0v.09a1.7 1.7 0 0 0 1.04 1.56 1.7 1.7 0 0 0 1.87-.34l.06-.06a2 2 0 1 1 2.83 2.83l-.06.06a1.7 1.7 0 0 0-.34 1.87v.09a1.7 1.7 0 0 0 1.56 1.04H19.5a2 2 0 1 1 0 4h-.09a1.7 1.7 0 0 0-1.56 1.04z" />
  </svg>
)

// ticket #216: small chevron for the "More" disclosure toggle (secondary destinations).
export const IconChevronDown = ({ open }) => (
  <svg
    width="14"
    height="14"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    style={{
      transition: "transform .15s ease",
      transform: open ? "rotate(180deg)" : "rotate(0deg)",
    }}>
    <path d="M6 9l6 6 6-6" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
)
